import React from 'react'
import ReactDOM from "react-dom";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Modal, Button, Tabs, Tab } from 'react-bootstrap'
import { saveAs } from 'file-saver';

import RunTemplateResultGrid from './elements/RunTemplateResultGrid'

import classNames from 'classnames'

import { closeAllWindows } from './actions'

import styles from './windows.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCross, faStopCircle, faTimes, faTimesCircle, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { pathOr, cond, equals, always, propOr } from "ramda";
import Copy from "../copy";

class RunTemplateResult extends React.Component {
  downloadAs = (content, extension) => () => {
    const mimeType = cond([
      [equals("json"), always("application/json;charset=utf-8")],
      [equals("csv"), always("text/csv;charset=utf-8")],
      [equals("xml"), always("text/xml;charset=utf-8")],
      [equals("yaml"), always("text/yaml;charset=utf-8")],
    ])(extension)

    const blob = new Blob([content], {type: mimeType});
    saveAs(blob, `Parser-Results.${extension}`);
  }

  render() {
    const extractedText = this.props.runTemplateResult.documentText && this.props.runTemplateResult.documentText.replace(/(\r\n|\n|\r)/gm, "<br>")
    const parsingLog    = JSON.stringify(this.props.runTemplateResult.parsingLog, null, 2)
    const jsonResult    = this.props.runTemplateResult.jsonResult && JSON.parse(this.props.runTemplateResult.jsonResult.replace(/(\r\n|\n|\r)/gm, ""))
    const jsonResultParsed = JSON.stringify(jsonResult || "", null, 2);
    const yamlResult = propOr('', 'yamlResult', this.props.runTemplateResult);
    const csvResult = propOr('', 'csvResult', this.props.runTemplateResult);
    const xmlResult = propOr('', 'xmlResult', this.props.runTemplateResult);

    //console.log("this.props.runTemplateResult.xmlResult", this.props.runTemplateResult.xmlResult)

    return (
      <div id="run-template-result-window" className="collapsible-window">
        <div className="collapsible-window-header">
          Output Results Extracted Using Your Template
          <button onClick={this.props.closeAllWindows} className="close close-btn">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="collapsible-window-body">
          <Tabs 
          
          // trying to fix issue with modal appearing behind some existing elements
          fade={false}
          animation={false}      
          transition={false}
          className="first-tabs"
          // end of the fix

          defaultActiveKey="parsing-result" id="run-template-result">
            <Tab eventKey="parsing-result" title="Parser Results">
              <Tabs 
                  // trying to fix issue with modal appearing behind some existing elements
                  fade={false}
                  animation={false}      
                  transition={false}
                  variant={'pills'}
                  // end of the fix   
                defaultActiveKey="result-grid" id="run-template-formats">
                <Tab eventKey="result-grid" title="Grids">
                  <div className="container-fluid text-left">
                    <div className="row">
                      <div className="col-lg-12 text-left">
                        <div className="code mT-5">
                          {jsonResult && <RunTemplateResultGrid objects={jsonResult["objects"]} />}
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="result-json" title="JSON">
                  <div className="container-fluid text-left">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="code mT-5">
                          <div className="d-flex justify-content-end">
                            <Button variant="primary" onClick={this.downloadAs(jsonResultParsed, "json")}>
                              Download as JSON
                            </Button>
                          </div>

                          <div className="copyIconWrap">
                            <div className="copyIcon">
                              <Copy data={jsonResultParsed}/>
                            </div>
                            <textarea className="form-control" name="" id="" rows={jsonResultParsed.match(/^/gm).length || 30 } value={JSON.stringify(jsonResult, null, 2)} disabled></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="result-csv" title="CSV">
                  <div className="container-fluid text-left">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="code mT-5">
                          <div className="d-flex justify-content-end">
                            <Button variant="primary" onClick={this.downloadAs(csvResult, 'csv')}>
                              Download as CSV
                            </Button>
                          </div>

                          <div className="copyIconWrap">
                            <div className="copyIcon">
                              <Copy data={csvResult}/>
                            </div>
                            <textarea className="form-control" name="" id="" rows={csvResult.match(/^/gm).length || 30} value={this.props.runTemplateResult.csvResult} disabled></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="result-xml" title="XML">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="code mT-5">
                          <div className="d-flex justify-content-end">
                            <Button variant="primary" onClick={this.downloadAs(xmlResult, "xml")}>
                              Download as XML
                            </Button>
                          </div>

                          <div className="copyIconWrap">
                            <div className="copyIcon">
                              <Copy data={xmlResult}/>
                            </div>
                            <textarea className="form-control" name="" id="" rows={xmlResult.match(/^/gm).length || 30} value={xmlResult} disabled></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="result-yaml" title="YAML">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="code mT-5">
                          <div className="d-flex justify-content-end">
                            <Button variant="primary" onClick={this.downloadAs(yamlResult, "yaml")}>
                              Download as YAML
                            </Button>
                          </div>

                          <div className="copyIconWrap">
                            <div className="copyIcon">
                              <Copy data={yamlResult}/>
                            </div>
                            <textarea className="form-control" name="" id="" rows={yamlResult.match(/^/gm).length || 30} value={yamlResult} disabled></textarea>
                          </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </Tab>
            <Tab eventKey="extracted-document-text" title="Extracted as Plain Text">
              <div className="container-fluid text-left form-control">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="copyIconWrap">
                      <div className="copyCSVIcon">
                        <Copy data={this.props.runTemplateResult.documentText}/>
                      </div>
                    </div>
                    <div className="code mT-20" dangerouslySetInnerHTML={{__html: extractedText}}>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="template-code" title="Template Code">
              <div className="container-fluid text-left">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="code mT-20">
                      <div className="copyIconWrap">
                        <div className="copyIcon">
                          <Copy data={JSON.stringify(this.props.template, null, 2)}/>
                        </div>
                        <textarea className="form-control" name="" id="" rows="30" value={JSON.stringify(this.props.template, null, 2)} disabled></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="parsing-log" title="Parsing Log">
              <div className="container-fluid text-left form-control">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="copyIconWrap">
                      <div className="copyCSVIcon">
                        <Copy data={parsingLog}/>
                      </div>
                    </div>
                    <div className="code mT-20" dangerouslySetInnerHTML={{__html: parsingLog}}>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    runTemplateResult: state.pdfViewer.runTemplateResult,
    template: state.template
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    closeAllWindows
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(RunTemplateResult)
